import React, { useReducer, useState } from 'react';
import Input from '../../shared/Inputs';
import Modal from '../../shared/Modal';
import SubscribeNow from '../../shared/SubscribeNow';

const formReducer = (state, event) => {
	return {
		...state,
		[event.name]: event.value,
	};
};

const ConnectTab = ({
	org,
	current_user,
	is_admin,
	part_of_org,
	mask_content,
	organization_visits,
	clickable_material_ids,
	visits_to_show,
	organization,
	view_more_access,
	share_profile_invitations,
	body_content,
}) => {
	const [formData, setFormData] = useReducer(formReducer, {
		full_name: '',
		email: '',
		body: '',
	});
	const [modalState, setModalState] = useState(false);
	const [visible, setVisible] = useState(false);

	const modalContent = () => {
		return (
			<>
				<h4>Are you ready?</h4>
				<h5>
					Be sure to upload your sponsorship materials and include
					your campaign details - then click send to connect!
				</h5>
				<br />
				{current_user && (is_admin || part_of_org) ? (
					<form action="/share_profiles" method="post">
						<Input
							inputType="share_profile[full_name]"
							type="full_name"
							label="Full name"
							placeholder="Joe Smith"
							data={formData}
						/>
						<Input
							inputType="share_profile[email]"
							type="email"
							label="Email"
							placeholder="email@example.com"
							data={formData}
						/>
						<textarea
							name="share_profile[body]"
							data={formData}
							defaultValue={body_content}
						></textarea>

						<input
							type="hidden"
							name="org_id"
							value={organization.id}
						></input>
						<div className="text-right">
							<div className="primary-button">
								<input
									type="submit"
									value="Send"
									className="primary-button"
									style={{ color: 'white' }}
								/>
							</div>
						</div>
					</form>
				) : null}
			</>
		);
	};

	return (
		<div id="connect-tab">
			<div className="row">
				<div className="columns small-12">
					<h3>Share profiles</h3>
					<div
						className="primary-button open-logo-upload open-modal"
						data-modal="share-profile-modal"
						onClick={() => setModalState(true)}
					>
						<p>Send share profile</p>
					</div>
				</div>
			</div>

			<div className="row" id="visitor-activity">
				<div className="columns masking-wrapper guard-for-empty">
					{mask_content ? <SubscribeNow /> : null}
					{organization_visits ? (
						<table>
							<thead>
								<tr>
									<th colSpan="1">Visiting user</th>
									<th colSpan="1">Invite date</th>
									<th colSpan="1">Visit date</th>
									<th colSpan="1">Total visit time</th>
									<th colSpan="1">Overview tab</th>
									<th colSpan="1">Campaigns tab</th>
									{clickable_material_ids.map(
										(material_id, index) => {
											<th colSpan="2" key={index}>
												<img
													src={material_id}
													height={100}
													width={100}
													crop="limit"
												/>
												{/* <%= cl_image_tag(mid, :format => :png, :height => 100, :crop => :limit) %> */}
											</th>;
										}
									)}
								</tr>
								<tr>
									<th scope="col"></th>
									<th scope="col"></th>
									<th scope="col"></th>
									<th scope="col">
										<i className="far fa-clock"></i>
									</th>
									<th scope="col">#</th>
									<th scope="col">#</th>
									{clickable_material_ids.map(
										(material_id, index) => {
											<div key={index}>
												<th scope="col">#</th>
												<th scope="col">
													<i className="far fa-clock"></i>
												</th>
											</div>;
										}
									)}
								</tr>
							</thead>
							<tbody className="visitor-activity-table-body">
								{organization_visits.map((visitData, index) => {
									return (
										<>
											{index < visits_to_show ? (
												<tr
													className={
														index >= 3 && !visible
															? 'hide'
															: ''
													}
													key={index}
												>
													<td data-label="User">
														{visitData.visit
															.user ? null : ( //NOT SURE WHAT GOES HERE
															<>
																{visitData.visit
																	.visitor_email ? (
																	<a
																		href={
																			'mailto:' +
																			visitData
																				.visit
																				.visitor_email
																		}
																	>
																		{
																			visitData
																				.visit
																				.visitor_email
																		}
																	</a>
																) : (
																	<>
																		{
																			visitData.user_identifier
																		}
																	</>
																)}
															</>
														)}
													</td>
													<td data-label="Invite date">
														{visitData.invite_date}
													</td>
													<td data-label="Visit date">
														{visitData.visit_date}
													</td>
													<td data-label="Visit time">
														{visitData.visit_time}
													</td>
													<td data-label="Overview tab count">
														{
															visitData.overview_count
														}
													</td>
													<td data-label="Opportunities tab count">
														{
															visitData.opportunities_count
														}
													</td>
													{clickable_material_ids.map(
														(mid) => {
															<>
																<td data-label="Analytics">
																	{mid.count}
																</td>
																<td data-label="Analytics">
																	{
																		mid.duration
																	}
																</td>
															</>;
														}
													)}
												</tr>
											) : null}
										</>
									);
								})}
							</tbody>
						</table>
					) : null}
					<div className="view-more-visits-container text-center">
						{view_more_access ? (
							<a
								className={
									'view-more-visits-btn' +
									(visible ? ' hide' : '')
								}
								onClick={() => setVisible(true)}
							>
								{' '}
								View more...
							</a>
						) : (
							<a href="/accounts">
								Upgrade your account to view more visits
							</a>
						)}
						<div
							className={
								'update-account-visits' +
								(visible ? '' : ' hide')
							}
						>
							{visits_to_show < organization_visits.length ? (
								<a href="">
									Upgrade your account to view all visits{' '}
								</a>
							) : null}
						</div>
					</div>
				</div>
				{organization.type === 'Property' ? (
					<table>
						<thead>
							<tr>
								<th>Invitations sent</th>
								<th />
							</tr>
						</thead>
						<tbody>
							{share_profile_invitations.map((spi) => {
								return (
									<tr>
										<td data-label="Email">spi.email</td>
										<td data-label="Date">
											spi.invite_date
										</td>
									</tr>
								);
							})}
						</tbody>
					</table>
				) : null}
			</div>

			<Modal
				Content={modalContent}
				modalState={modalState}
				turnOffModal={() => {
					setModalState(false);
				}}
			/>
		</div>
	);
};

export default ConnectTab;
